import React, { Component } from 'react';
import { AppConstants } from '../../core/constants';
import { fixNumbers } from '../../core/utils';
import service from '../../core/service';
import * as yup from 'yup';
import { toast } from 'react-toastify';



interface IProps {

}

interface IState {
  str: string;
  anchorEl: null | HTMLElement;
  open: any,
  openAddModal: boolean;
  openActionModal: boolean;
  loading: boolean;
  stagesList?: any;
  page: number;
  count: number;
  title: string;
  name: string;
  errorsList:any;
  openEditModal: boolean;
  selectedItem:any;
  estimate:string;
  priority:string;
  openConfirmModal: boolean;
  isCreating: boolean;
  isUpdating: boolean;
  isDeleting: boolean;
  rowsCountList:any;



}

export class StageController extends Component<IProps, IState> {

  datePickerRef: any;

  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
  }

  state: IState = {
    str: "",
    anchorEl: null,
    open: false,
    openAddModal: false,
    openActionModal: false,
    loading: false,
    stagesList: [],
    page: 1,
    errorsList:[],
    title: "",
    name:"",
    count: 6,
    rowsCountList:[6, 10, 50, 100],
    openEditModal: false,
    selectedItem:null,
    estimate:"",
    priority:"",
    openConfirmModal: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  };
  handleClick = (event: React.MouseEvent<HTMLElement>) => {
    this.setState({ anchorEl: this.state.anchorEl ? null : event.currentTarget });
    this.setState({ open: this.state.anchorEl ? null : Boolean(event.currentTarget) });

  };
  emptyCount= () => {
    this.setState({ count: 6, page:1 });
  };
  paginationRowTimeOut: string | number | NodeJS.Timeout | undefined;
  handleCount = (value: any) => {
    this.setState({ count: value, page: 1 });
    clearTimeout(this.paginationRowTimeOut);
    this.paginationRowTimeOut = setTimeout(() => {
      this.getStagesList()
    }, 800);
  }
  getStagesList = async () => {
    this.setState({ loading: true })
    const { page, count } = this.state;
    let parameters = {
      page: page ? page.toString() : "1",
      count: count ? count.toString() : "6",

    }
    let url = new URL(`${AppConstants.base_url_api}lead/stages/${window.location.pathname.split("/")[2]}`)
    for (const [key, value] of Object.entries(parameters)) {
      if (value) {
        url.searchParams.append(key, value)
      }
    }
    try {
      const response = await service.Stage.list(url.search);
      if (response) {
        this.setState({ stagesList: response?.data?.data, openAddModal: false, loading: false })
      } else {
        this.setState({ loading: false })
      }
    } catch (error) {
      // throw error;
    }
  };
  paginationTimeOut: string | number | NodeJS.Timeout | undefined;
  handleChangePage = (event: React.ChangeEvent<unknown>, value: number) => {
    this.setState({ page: value })
    clearTimeout(this.paginationTimeOut);
    this.paginationTimeOut = setTimeout(() => {
      this.getStagesList()
    }, 800);
  }

  handleRemove = (item:any) =>{
    this.setState({openConfirmModal: true, selectedItem: item})

  }
  handleUpdate = (item:any) =>{
    this.setState({selectedItem: item,
         openEditModal: true, title: item?.title, name: item?.name,
        priority: item?.priority, estimate: item?.estimate_percent})

  }
  async sendUpdate () {
    const { title, name, priority, estimate, selectedItem } = this.state;
    this.setState({ isUpdating: true });
    const schema = yup.object({
        title: yup.string().required(" عنوان اجباری می‌باشد"),
        name: yup.string().required(" نام اجباری می‌باشد"),
        estimate: yup.number().nullable().transform((_, val) => (val !== "" ? Number(val) : null))
        .max(100, 'تخمین نمی‌تواند بیشتر از ۱۰۰ باشد')
        });   
        try {
          await schema.validate({ title, name, estimate }, { abortEarly: false });
          const response = await service.Stage.update( name, title,  priority !== "" ? parseInt(priority) : 0,
          estimate !== "" ? parseInt(estimate) : 0, selectedItem?.id );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openEditModal: false, title:"", name:"", priority:"", estimate:"" });
                    this.getStagesList();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                    this.setState({ errorsList:[], openEditModal: false, title:"", name:"", priority:"", estimate:"" });
                }
            } else {
                this.setState({ loading:false, errorsList:[], openEditModal: false, title:"", name:"", priority:"", estimate:"" });
                toast.error("مشکلی پیش آمده‌است");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }    
        finally {
          this.setState({ isUpdating: false });
        }
  }
  async handleNewStage () {
    const { title, name, priority, estimate } = this.state;
    this.setState({ isCreating: true });
    const schema = yup.object({
        title: yup.string().required(" عنوان اجباری می‌باشد"),
        name: yup.string().required(" نام اجباری می‌باشد"),
        estimate: yup.number().nullable().transform((_, val) => (val !== "" ? Number(val) : null))
        .max(100, 'تخمین نمی‌تواند بیشتر از ۱۰۰ باشد')
        });   
        try {
          await schema.validate({ title, name, estimate }, { abortEarly: false });
          const response = await service.Stage.create( name, title, priority !== "" ? parseInt(priority) : 0,
           estimate !== "" ? parseInt(estimate) : 0 );
            if (response) {
                if(response?.status === 200){
                    this.setState({ errorsList:[], openAddModal: false, title:"", name:"", priority:"", estimate:"" });
                    this.getStagesList();
                    toast.success("با موفقیت ارسال شد");
                }
                else{
                    toast.error("مشکلی پیش آمده‌است");
                    this.setState({ errorsList:[], openAddModal: false, title:"", name:"", priority:"", estimate:"" });
                }
            } else {
                this.setState({ loading:false, errorsList:[], openAddModal: false, title:"", name:"", priority:"", estimate:"" });
                toast.error("مشکلی پیش آمده‌است");

            }  
        } catch (err: any) {
          this.setState({ errorsList: err.inner  })
        }
        finally {
          this.setState({ isCreating: false });
        }
  }
  async confirmDelete  () {
    const { selectedItem } = this.state;
      this.setState({ isDeleting: true });
      const response = await service.Stage.delete(selectedItem?.id);
      if (response) {
        if(response.status === 200){
          toast.success("با موفقیت حذف شد");
          this.setState({selectedItem:null, openConfirmModal: false});
          this.getStagesList();
  
        }
        else{
          toast.error("مشکلی پیش آمده‌است");
        }
      } else {
        this.setState({ loading: false });
        toast.error("مشکلی پیش آمده‌است");
      }
      this.setState({ isDeleting: false });
    }
}
export default StageController;